<div class="login-card">
  <div>
    <div>
      <a class="logo" routerLink="/">
        <!-- <img class="img-fluid for-light" src="assets/images/logo/logo.png" alt="loginPage" /> -->
        <!-- <img class="img-fluid for-dark" src="assets/images/logo/logo_dark.png" alt="loginPage" /> -->
        <img class="img-fluid for-light" src="assets/images/logo/reportLogo.png" alt="loginPage" />
        <img class="img-fluid for-dark" src="assets/images/logo/reportLogo.png" alt="loginPage" />
      </a>
    </div>
    <div class="login-main">
      <form class="theme-form">
        <h4>{{'Create Your Account' | translate}}</h4>
        <p>{{'Enter Personal Details' | translate}}</p>
        <div class="form-group">
          <label class="col-form-label pt-0">{{'Forms.Full Name' | translate}}</label>
          <input class="form-control" type="text" required="" placeholder="{{'Forms.Full Name' | translate}}">
        </div>
        <div class="form-group">
          <label for="address" class="form-label">{{'Forms.Address' | translate}}</label>
          <input id="address" class="form-control" type="text" required="" placeholder="{{'Forms.Address' | translate}}">
        </div>
        <div class="form-group">
          <div class="row">
            <div class="col-md-6">
              <!-- [ngClass]="{'errorInput': formSubmitted && !formValid && f['nationality_id'].errors, 'isValid': formSubmitted && !f['nationality_id'].errors }" -->
              <label for="Nationalities" class="form-label">{{'Forms.Nationality' | translate}}</label>
              <!-- <select
                class="form-select" 
                
                required id="Nationalities">
                <option value="" disabled selected>{{'Forms.Choose Nationality' | translate}}</option>
                <option *ngFor="let nationality of nationalities" [value]="nationality.id">{{ isDirRTL ? nationality.nationality_name : nationality.nationality_name_latin}}</option>
              </select> -->
              <!-- <label for="Nationalities" class="form-label">{{'Forms.Nationality' | translate}}</label>
              <select class="form-select" required="" id="Nationalities">
                <option value="">{{'Forms.Choose Nationality' | translate}}</option>
                <option *ngFor="let country of countries?.data" [value]="country.id">{{ isDirRTL ? country.country_name : country.country_name_latin}}</option>
              </select> -->
            </div>
            <div class="col-md-6">
              <label for="nationalId" class="form-label">{{'Forms.National Id' | translate}}</label>
              <input type="text" class="form-control" id="nationalId" required placeholder="{{'Forms.National Id' | translate}}">
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="row">
            <div class="col-md-6">
              <label class="col-form-label">{{'Forms.Email' | translate}}</label>
              <input class="form-control" type="email" required="" placeholder="app@yourmail.com">
            </div>
            <div class="col-md-6">
              <label for="phone" class="form-label">{{'Forms.Phone' | translate}}</label>
              <input type="text" class="form-control" id="phone" required placeholder="{{'Forms.Phone' | translate}}">
            </div>
          </div>
        </div>
        <div class="form-group mb-3">
          <div>
            <button class="transparent-button change-language" (click)="changeLanguage(translate.currentLang == 'ar' ? 'en' : 'ar');customizeLayoutType(translate.currentLang == 'ar' ? 'rtl' : 'ltr')">
              <img src="assets/svg/translate.svg" alt="">
              <span *ngIf="translate.currentLang == 'ar'">الإنجليزية</span>
              <span *ngIf="translate.currentLang == 'en'">Arabic</span>
            </button>
          </div>
        </div>
        <div class="form-group mb-0">
          <button class="btn btn-primary d-block w-100" type="button">{{'Create Account' | translate}}</button>
        </div>
        <p class="mt-4 mb-0">{{'Already Have Account' | translate}}<a class="ms-2" [routerLink]="'/auth/login'">{{'Forms.Sign In' | translate}}</a></p>
      </form>
    </div>
  </div>
</div>